const getFingerprint = ({ fraudAnalysisState }) => fraudAnalysisState.fingerprint;

export { getFingerprint };
